import { render, staticRenderFns } from "./elem-form-item.vue?vue&type=template&id=545a7260&scoped=true&"
import script from "./elem-form-item.vue?vue&type=script&lang=js&"
export * from "./elem-form-item.vue?vue&type=script&lang=js&"
import style0 from "./elem-form-item.vue?vue&type=style&index=0&id=545a7260&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545a7260",
  null
  
)

export default component.exports